export const AUTH_REQUIRED =
  'authRequired';


export enum RoutePaths {

  // ==========================================================
  // Public
  // ==========================================================
  root = '',

  players_and_parents = 'players-and-parents',
  club_owners_and_teachers = 'club-owners-and-teachers',

  login = 'login',
  register = 'register',
  onboarding = 'onboarding',

  reset_password = 'login/reset-password',
  reset_password_action = 'login/reset-password/:token/:result',

  login_with_token = 'login/login-with-token',
  login_with_token_action = 'login/login-with-token/:token/:result',

  invites =  'invite/:id',
  household_invite = 'household/invite/:inviteId',
  invites_action =  'invite/:id/:result',

  // ----------------------------------------------------------
  // Clubs
  // ----------------------------------------------------------
  clubs = 'clubs',
  club_with_id = 'clubs/:clubId',
  public_term_details = 'clubs/:clubId/term/:termId',
  register_club_term = 'clubs/:clubId/term/:termId/register',


  // ==========================================================
  // Dashboard
  // ==========================================================
  dashboard = 'dashboard',
  dashboard_notifications = 'dashboard/notifications',

  // ----------------------------------------------------------
  // Account
  // ----------------------------------------------------------
  dashboard_account = 'dashboard/account',
  dashboard_account_clubs = 'dashboard/account/clubs',
  dashboard_account_sessions = 'dashboard/account/sessions',
  dashboard_account_security = 'dashboard/account/security',

  dashboard_households = 'dashboard/households',
  dashboard_household_with_id = 'dashboard/households/:householdId',
  dashboard_household_children = 'dashboard/households/:householdId/children',
  dashboard_household_invites = 'dashboard/households/:householdId/invites',
  dashboard_household_invoices = 'dashboard/households/:householdId/invoices',
  dashboard_household_invoice_with_id = 'dashboard/households/:householdId/invoices/:invoiceId',
  dashboard_household_child = 'dashboard/households/:householdId/children/:childAccountId',
  dashboard_household_child_settings = 'dashboard/households/:householdId/children/:childAccountId/settings',

  // ----------------------------------------------------------
  // Clubs
  // ----------------------------------------------------------
  dashboard_clubs =  'dashboard/clubs',
  dashboard_club_create = 'dashboard/clubs/create',
  dashboard_club_with_id = 'dashboard/clubs/:clubId',
  dashboard_club_edit_with_id = 'dashboard/clubs/:clubId/edit',

  // ----------------------------------------------------------
  // Staff
  // ----------------------------------------------------------
  dashboard_club_staff = 'dashboard/clubs/:clubId/staff',

  // ----------------------------------------------------------
  // Students
  // ----------------------------------------------------------
  dashboard_club_students =  'dashboard/clubs/:clubId/students',

  // ----------------------------------------------------------
  // Sessions
  // ----------------------------------------------------------
  dashboard_club_sessions = 'dashboard/clubs/:clubId/sessions',
  dashboard_club_session_with_id = 'dashboard/clubs/:clubId/sessions/:classSessionId',

  // ----------------------------------------------------------
  // Payments
  // ----------------------------------------------------------
  dashboard_club_payments = 'dashboard/clubs/:clubId/payments',

  // ----------------------------------------------------------
  // Club invoices
  // ----------------------------------------------------------
  dashboard_club_invoices = 'dashboard/clubs/:clubId/invoices',
  dashboard_club_invoice_with_id = 'dashboard/clubs/:clubId/invoices/:invoiceId',


  // ----------------------------------------------------------
  // Classes
  // ----------------------------------------------------------
  dashboard_classes = 'dashboard/clubs/:clubId/classes',


  // ----------------------------------------------------------
  // Terms
  // ----------------------------------------------------------
  dashboard_terms = 'dashboard/clubs/:clubId/terms',
  dashboard_term_create =   'dashboard/clubs/:clubId/terms/create',
  dashboard_term_with_id =  'dashboard/clubs/:clubId/terms/:termId',
  dashboard_term_edit_with_id =  'dashboard/clubs/:clubId/terms/:termId/edit',
  dashboard_term_registrations_with_id = 'dashboard/clubs/:clubId/terms/:termId/registrations',
  dashboard_term_invitation_create = 'dashboard/clubs/:clubId/terms/:termId/invitations/create',


  // ----------------------------------------------------------
  // Payment providers
  // ----------------------------------------------------------
  dashboard_club_payment_provider_setup_hook = 'dashboard/clubs/:clubId/payment-providers/setup/hook/:paymentProviderId/:path',

}


// ============================================================
// Dashboard child paths
// ============================================================
//
// RoutePaths contains absolute application paths because those
// paths are useful to callers throughout the application.
//
// Angular child route definitions, however, must be relative to
// their parent.
//
// Keeping this conversion here means app.routes.ts no longer
// needs a second duplicate enum containing almost exactly the
// same route definitions.
//

export function dashboardChildPath(path: RoutePaths): string {

  if ( path === RoutePaths.dashboard) {
    return '';
  }

  const prefix = `${RoutePaths.dashboard}/`;

  if ( !path.startsWith(prefix)) {
    throw new Error(`Route "${path}" is not a dashboard route.`);
  }

  return path.substring(
    prefix.length
  );
}
